import React from 'react'
import Typography from '@material-ui/core/Typography'

const Notes = ({
  item,
}) => {


  return (
    <div>
      <Typography variant="body1">
        { item.notes }
      </Typography>
    </div>
  )
}

export default Notes